import * as storeConst from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";

export const state = {
  collections: {
    data: [],
    pagination: {
      current_page: 1,
      per_page: 5,
      count: 0,
      total: 0,
      total_pages: 0
    }
  }
};

export const getters = {
  [storeConst.GETTERS_COLLECTIONS_LIST]: state => {
    return state.collections;
  }
};

export const actions = {
  [storeConst.ACTIONS_GET_COLLECTIONS_LIST]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      const url = getEndPoints().programCollection.getCollectionByProgramId.replace(
        ":programId",
        options.programId
      );
      makeCall(url, buildOptions("GET", options), commit)
        .then(response => {
          resolve(response);
          commit(storeConst.MUTATIONS_SET_COLLECTIONS_LIST, response);
          if (options.callback) {
            options.callback();
          }
        })
        .catch(function(error) {
          EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, error);
        });
    });
  },

  [storeConst.ACTIONS_SAVE_COLLECTIONS]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      const url = getEndPoints().programCollection.saveCollection;
      makeCall(url, buildOptions("POST", options.data), commit)
        .then(response => {
          if (response) {
            resolve(response);
            commit(storeConst.MUTATIONS_SET_COLLECTIONS_LIST, response);
            if (options.successMessage) {
              EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
            }
            if (options.callback) {
              options.callback(response);
            }
          }
        })
        .catch(function(error) {
          const errMsg = error.response.data.error.message.title;
          EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, errMsg);
        });
    });
  },

  [storeConst.ACTIONS_REMOVE_COLLECTION_LIST]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      const url = getEndPoints().programCollection.removeCollectionList;
      makeCall(url, buildOptions("POST", options.data), commit)
        .then(response => {
          resolve(response);
          if (response && response.success) {
            EventBus.$emit(EVENT_TOAST_MESSAGE, "Removed successfully");
          }
          if (options.callback) {
            options.callback(response);
          }
        })
        .catch(function(error) {
          EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, error);
        });
    });
  },

  [storeConst.ACTIONS_CHECK_DELETE_ITEM]: ({ commit }, options) => {
    return new Promise((resolve, reject) => {
      const url = getEndPoints().programCollection.checkDeleteItem;
      makeCall(url, buildOptions("POST", options.data), commit)
        .then(response => {
          if (response) {
            resolve(response);
          }
        })
        .catch(function(error) {
          const errMsg = error.response.data.error.message.title;
          EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, errMsg);
        });
    });
  }
};

export const mutations = {
  [storeConst.MUTATIONS_SET_COLLECTIONS_LIST]: (state, payload) => {
    if (payload) {
      state.collections = payload;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_collection/index.js